import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { DlpSummary } from "../../components/dlp/DlpSummary";
import { AdditionalOptions } from "../../components/dlp/options/AdditionalOptions";
import { Step } from "../../components/stepIndicator/Step";
import { StepIndicator } from "../../components/stepIndicator/StepIndicator";
import { scrollToFirstValidationMessage } from "../../components/validationMessage/scrollToFirstValidationMessage";
import { useDidMount } from "../../hooks/useDidMount";
import { useDlpFlowContext } from "../../hooks/useDlpContext";
import { FlowLayout } from "../FlowLayout";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DlpFlowStepTwo = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { data, setters, goToStepThree, currentStep, goBack, modelState, setModelState } = useDlpFlowContext();

  const goToStep3 = async () => {
    try {
      setLoading(true);
      await goToStepThree(props.fields.Step3Path.value);
    } catch {
      setLoading(false);
      scrollToFirstValidationMessage();
    }
  };

  useDidMount(() => {
    if (currentStep !== 2) {
      goBack(1, props.fields.Step1Path.value);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }
  };

  if (currentStep !== 2) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={1}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
        <Step label={props.fields.step5Name.value} labelMobile={props.fields.step5MobileName.value} />
      </StepIndicator>
      <FlowLayout
        Sidebar={
          <DlpSummary
            {...props}
            submitButtonProps={{
              id: "button_submit_options",
              children: props.fields.SetOptionsSubmitButtonText.value,
              loading,
              onClick: goToStep3,
            }}
          />
        }
        {...props}
      >
        <AdditionalOptions
          fields={props.fields}
          data={data}
          onUpdateHasMortgage={setters.updateHasMortgage}
          onUpdateMortgageSupplierKey={setters.updateMortgageSupplier}
          onUpdateInsuranceTaker={setters.updateInsuranceTaker}
          onUpdateCrosswiseInsured={setters.updateCrosswiseInsured}
          setModelState={setModelState}
          modelState={modelState}
        />
      </FlowLayout>
    </>
  );
};
